import { UserReferenceModel } from './base';

export interface RoleUserListItem extends UserReferenceModel {
  profilePictureUrl: string;
  conventionIds: number[];
}

export interface RoleWithPermissions {
  description: string;
  id: number;
  name: string;
  permissions: string[];
}

export interface RoleInvite {
  code: string;
  expiresAt: Date | null;
  id: number;
  roleId: number;
  uses: number;
  maxUses: number | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateRoleInvitesPayload {
  amount: number;
  expiresAt: Date | null;
  maxUses: number | null;
}

export interface UpdateRoleInvitesPayload {
  expiresAt: Date | null;
  maxUses: number | null;
}

export interface RoleInviteResponse {
  code: string;
  expiresAt: Date | null;
  inviteId: number;
  role: {
    description: string;
    name: string;
    id: number;
  };
  userHasRole: boolean;
}

/// Internal roles can not be modified
/// Membership is managed by other actions
export function isSpecialRole(name: string): boolean {
  return name === 'lead' || name === 'dealerAssistant';
}
